import type { CondicaoId } from '@acme/core'
import { abono } from './abono'
import { afastamento } from './afastamento'
import { agendado } from './agendado'
import { calculo } from './calculo'
import { centroCusto } from './centro-custo'
import type { CondicaoUi } from './condicao-ui'
import { falta } from './falta'
import { foraCerca } from './fora-cerca'
import { funcionario } from './funcionario'
import { horasExtras } from './horas-extras'
import { local } from './local'
import { marcacaoFaltando } from './marcacao-faltando'

/**
 * Registro único da tela das condições, uma por arquivo. Condição nova no
 * catálogo do `@acme/core` sem entrada aqui não compila.
 */
export const CONDICOES_UI = {
    local,
    'centro-custo': centroCusto,
    funcionario,
    agendado,
    calculo,
    'marcacao-faltando': marcacaoFaltando,
    'fora-cerca': foraCerca,
    falta,
    'horas-extras': horasExtras,
    afastamento,
    abono,
} as const satisfies Record<CondicaoId, CondicaoUi>
